@if (newEditor.show) {
<app-new-editor
  #newEditorRef
  [template]="templateData"
  [variables]="variables"
  [title]="isVideoMode ? 'Personalize Video' : 'Social Share Editor'"
  (EditorStateChanged)="onEditorStateChanged($event)"></app-new-editor>
}
@if (editorDecided && newEditor.active && !newEditor.show) {
<div class="new-editor-saving">
  <div class="spinner-border text-secondary" role="status"><span class="visually-hidden">Saving...</span></div>
</div>
}
@if (editorDecided && !newEditor.active) {
<div  class="right-content" [style.marginLeft.px]="panelCollapsed ? 0 : panelWidth" style="transition: margin-left 0.3s;">
  <app-page-shell variant="wizard" [stickyChrome]="true" [withOps]="true">
  <div pageChrome>
    <app-status-bar [loading]="loader$ | async" [step]="step"
                      [skipLanding]="campaign?.landing_page_status === 'skipped'"
                      (SaveButtonClick)="onSaveButtonClick()">
      </app-status-bar>
  </div>
@if (!newEditor.active) {
<app-template-editor
        [customClasses]="'mt-3'"
        [panelCollapsed]="panelCollapsed"
        [panelWidth]="panelWidth"
        [template]="template" [viewportSize]="viewportSize"
        [socialImageSizes]="socialImageSizes"
      (OnTemplateLoaded)="templateLoaded($event)"
        (OnPageSettingsChanged)="onStylesCustomizationChange($event)"
        #templateEditor [pageSetting]="stylesForm.value" [variables]="variables"
        (OnTemplateTypeChange)="fetchRawTemplatesById($event)" [showTemplateSelector]="true" [showBlockSelector]="false"
        [rawTemplatesTypes]="rawTemplatesTypes" [templateType]="'socialShare'" [templates]="templates"></app-template-editor>
}
</app-page-shell>
</div>

@if (!panelCollapsed) {
<div class="toolbar-panel-resize-handle"
     [style.left]="panelWidth + 'px'"
     (pointerdown)="startResizing($event)">
</div>
}
<button class="toolbar-panel-toggle-button" 
        [style.left]="(panelCollapsed ? 0 : panelWidth) + 'px'"
        (click)="togglePanel()">
  {{ panelCollapsed ? '▶' : '◀' }}
</button>

<div class="operation-box">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-5">
        <div class="text-start">
          <button class="btn btn-default me-2" (click)="onBackButtonClick()" type="button">
            Back
          </button>
          @if (!currentUser?.can('view-advanced-editor', 'template')) {
          <button class="btn btn-default" [disabled]="!this.templateId" (click)="saveAsNewTemplateModel(saveAsTemplate, 'client')" type="button" [title]="(!this.templateId ?'Please save the template first and then edit again for this button to become enabled':'')">
            Save as template
          </button>
          }
          @if (currentUser?.can('view-advanced-editor', 'template')) {
          <div  class="btn-group dropup me-2" ngbDropdown placement="top-start">
            <button type="button"
                    [disabled]="(loader$ | async) || !isTemplateLoaded() || !this.templateId"
                    class="btn btn-default dropdown-toggle"
                    [title]="(!this.templateId ?'Please save the template first and then edit again for this button to become enabled':'')"
                    ngbDropdownToggle aria-haspopup="true">
              Template
            </button>
            <div class="dropdown-menu border-rad-10x" ngbDropdownMenu>
              <button [disabled]="(loader$ | async) || !isTemplateLoaded()"
                      (click)="saveAsNewTemplateModel(saveAsTemplate, 'client')"
                      class="dropdown-item" type="button">
                Save as template
              </button>
              <button [disabled]="(loader$ | async) || !isTemplateLoaded()"
                      class="dropdown-item"
                      (click)="saveAsNewTemplateModel(saveAsTemplate, 'public')">
                Save as public template
              </button>
            </div>
          </div>
          }
          @if (templateId) {
          <button [disabled]="!isTemplateLoaded()"
                  class="btn btn-default me-2"
                  (click)="showTemplateRevisions()">
            Undo All
          </button>
          }
          @if (!newEditor.active) {
          <button [disabled]="!isTemplateLoaded()"
                  class="btn btn-default"
                  (click)="showNewEditor()">
            New Editor
          </button>
          }
        </div>
      </div>
      <div class="col-md-4 d-flex justify-content-center">
        @if (!newEditor.active) {
        <app-device-toolbar
          (onPageSizeChange)="onPageSizeSelect($event)"
          (openCodeEditor)="onEditHtml()"></app-device-toolbar>
        }
      </div>
      <div class="col-md-3">
        <div class="text-end">
          <button [disabled]="!isTemplateLoaded()" (click)="saveClientTemplate()"
                  class="btn btn-primary me-2">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

}

<ng-template #saveAsTemplate let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-title">Save template as</h4>
    <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title"
            (click)="modal.dismiss('cancel')"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="templateForm">
    <div class="row">
      <div class="col-md-12">
        <div class='input-group input-group-sm'>
          <input class="form-control" formControlName="saveAsTemplateName" placeholder="Template Name" [style]="{background: 'none'}"
                 type="text" [class.is-invalid]="saveAsTemplateNameSubmit && !saveAsTemplateName">
        </div>
        @if (!saveAsTemplateName && saveAsTemplateNameSubmit) {
        <div class="bar error-brd">
          <div class="invalid-text">Enter template name</div>
        </div>
        }
      </div>
    </div>

    <div class="row my-2">
      <div class="col-md-12">
          <div class="d-flex align-items-center">
            <small>Influencer Type</small>
          </div>
          <div class='input-group input-group-sm'>
            <select class="floating-select" formControlName="influencer_type_id" (ngModelChange)='changingInfluencerType($event)'
                    [class.is-invalid]="submitted">
              @for (influencerType of influencerTypes; track influencerType) {
              <option [value]='influencerType.id'
                     >{{influencerType.name}}</option>
              }
            </select>
          </div>
      </div>
    </div>
    </form>
  </div>
  <input type="hidden" ngbAutofocus>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="modal.close()">Close</button>
    <button type="button" class="btn btn-primary" (click)="saveAsNewTemplate(modal)">Submit</button>
  </div>
</ng-template>
